import { ArchiveDefaultLearnCertConfigItem } from './archive-default-learn-cert-config-item';
import { DefaultLearnCertConfig } from './default-learn-cert-config';
import {
  JsonConverter,
  JsonCustomConvert,
  JsonObject,
  JsonProperty
  } from 'json2typescript';
import { JsonUtil } from '../../../service/util/json.util';
import { LearnCert } from '../learn-cert';


@JsonConverter
export class DefaultLearnCertConfigsConverter implements JsonCustomConvert<DefaultLearnCertConfig[]> {
  serialize(defaultLearnCertConfigs: DefaultLearnCertConfig[]): any {
    return defaultLearnCertConfigs;
  }

  deserialize(defaultLearnCertConfigs: any): DefaultLearnCertConfig[] {
    defaultLearnCertConfigs = defaultLearnCertConfigs || [];
    return JsonUtil.jsonConvert(defaultLearnCertConfigs, DefaultLearnCertConfig);
  }
}

@JsonConverter
export class LearnCertsConverter implements JsonCustomConvert<LearnCert[]> {
  serialize(learnCerts: LearnCert[]): any {
    return learnCerts;
  }

  deserialize(learnCerts: any): LearnCert[] {
    learnCerts = learnCerts || [];
    return JsonUtil.jsonConvert(learnCerts, LearnCert);
  }
}

@JsonObject
export class DefaultLearnCertConfigDTO {
  @JsonProperty('defaultLearnCertConfigs', DefaultLearnCertConfigsConverter)
  defaultLearnCertConfigs: DefaultLearnCertConfig[] = [];

  @JsonProperty('learnCerts', LearnCertsConverter)
  learnCerts: LearnCert[] = [];

  findLearnCertByArchiveId(archiveId: number): LearnCert {
    let archiveItem: ArchiveDefaultLearnCertConfigItem;
    this.defaultLearnCertConfigs.forEach(config => {
      archiveItem = config.archiveConfigItems.find(item => item.archiveId === archiveId);
    });
    if (archiveItem) {
      return this.learnCerts.find(learnCert => learnCert.id === archiveItem.learnCertId);
    }
    return new LearnCert();
  }

  findTenantId() {
    return this.defaultLearnCertConfigs.length === 0 ? undefined : this.defaultLearnCertConfigs[0].tenantId;
  }
}
